import api from '../instance';
import { ITicket, IMessage, IAttachment, ICategory } from '../../types/tickets';

interface IFetchTicketsParams {
  per_page?: number;
  page?: number;
  order_by_direction?: 'desc' | 'asc';
}

interface IFetchTicketsResponse {
  data: ITicket[];
  perPage: string;
  total: number;
  hash: string;
}

type TFetchOneTicketResponse = ITicket;

interface IUpdateTicketParams {
  resolved: number;
}

type TUpdateTicketResponse = ITicket;

interface IReplyToTicketParams {
  attachments: IAttachment[];
  message: string;
  ticket_id: number;
}

type TReplyToTicketResponse = IMessage;

interface IAttachFileToMessageParams {
  file: string;
  name: string;
  size: number;
}

type TAttachFileToMessageResponse = IAttachment;

type TFetchCategoriesResponse = ICategory[];

interface ICreateTicketParams {
  category: number;
  email: string;
  message: string;
}

type TCreateTicketResponse = ITicket;

type TMarkMessagesAsRead = ITicket;

interface IFetchUnreadTicketsMessagesResponse {
  data: {
    hash: string;
    ticketMessages: IMessage[];
  };
}

interface IFetchOneTicketParams {
  hash?: string;
}

const fetchTickets = (params: IFetchTicketsParams): Promise<IFetchTicketsResponse> =>
  api.get('/ticket', { params });

const fetchOneTicket = (
  ticketId: string,
  params: IFetchOneTicketParams,
): Promise<TFetchOneTicketResponse> => api.get(`/ticket/${ticketId}`, { params });

const updateTicket = (
  ticketId: string,
  params: { hash: string },
  body: IUpdateTicketParams,
): Promise<TUpdateTicketResponse> => api.put(`/ticket/${ticketId}`, body, { params });

const replyToTicket = (
  ticketId: string,
  params: { hash: string },
  body: IReplyToTicketParams,
): Promise<TReplyToTicketResponse> => api.post(`/ticket/${ticketId}/message`, body, { params });

const saveAttachment = (body: IAttachFileToMessageParams): Promise<TAttachFileToMessageResponse> =>
  api.post(`/ticket/attachment`, body);

const fetchCategories = (): Promise<TFetchCategoriesResponse> => api.get(`/request-category/list`);

const createTicket = (body: ICreateTicketParams): Promise<TCreateTicketResponse> =>
  api.post(`/ticket`, body);

const fetchUnreadTicketsMessages = (): Promise<IFetchUnreadTicketsMessagesResponse> =>
  api.get(`/unread`);

const markMessagesAsRead = (
  ticketId: number,
  params: { hash: string },
  body: { read: number },
): Promise<TMarkMessagesAsRead> => api.put(`ticket/${ticketId}`, body, { params });

export default {
  fetchTickets,
  fetchOneTicket,
  updateTicket,
  replyToTicket,
  saveAttachment,
  fetchCategories,
  createTicket,
  fetchUnreadTicketsMessages,
  markMessagesAsRead,
};
